import { Tooltip } from "antd";
import { Download, ExternalLink, HelpCircle } from "lucide-react";
import React, { useState } from "react";
import WebUtils from "../../../../utils/WebUtils";
import { viewResume } from "../../../../api/b2b-candidate";
import CreateResumeCopyReport from "../optimizeResume/modals/CreateResumeCopyReport";

const ReportHeader = ({
  matchData,
  handleDownload,
  userDetail,
  setLoading,
}) => {
  const [saveCopyModal, setSaveCopyModal] = useState(false);

  const viewResumeApi = (resumeId) => {
    const url = `${viewResume}?resumeIdentifier=${
      resumeId || null
    }&userIdentifier=${userDetail?.userIdentifier}`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          window.open(result?.data?.data, "_blank");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  return (
    <>
      {saveCopyModal && (
        <CreateResumeCopyReport
          saveCopyModal={saveCopyModal}
          setSaveCopyModal={setSaveCopyModal}
          setLoading={setLoading}
          resumeMetaData={matchData}
          userDetail={userDetail}
          //   buildSavePayload={studio?.buildSavePayload}
          //   generatePdfBlob={generatePdfBlob}
        />
      )}
      <div className="sticky top-0 z-10 py-3 px-[1.2rem] bg-[#0F1B23] border border-[#103662] rounded-t-md shadow ">
        <div className="text-[.9rem] text-[#FCFCFD] flex flex-wrap justify-between gap-x-3 gap-y-4 items-center">
          <div>
            <div className="flex gap-x-1 gap-y-1 flex-wrap items-center">
              <span className="font-semibold">
                {matchData?.resumeFileName || "--"}
              </span>{" "}
              <span>({matchData?.resumeIdentifier || "N/A"})</span>{" "}
              <ExternalLink
                onClick={() => viewResumeApi(matchData?.resumeIdentifier)}
                className="text-[#EDC043] ml-2 hover:text-amber-200 cursor-pointer transition-all duration-200"
                size={17.5}
              />
            </div>
            <div className="mt-1 flex gap-[.3rem] items-center flex-wrap">
              <span className="font-semibold">
                {matchData?.jobTitle || "--"}
              </span>{" "}
              ({matchData?.jdIdentifier || "N/A"})
            </div>
          </div>
          <div className="ml-auto">
            <div className="text-right mb-1 text-[.85rem]">
              <span className="font-semibold"> Report ID:</span>{" "}
              {matchData?.matchAnalysisIdentifier || "N/A"}
            </div>

            <div className="flex items-center gap-2 flex-wrap">
              <button
                onClick={handleDownload}
                className="text-[.8rem] btn-white px-3 py-[.4rem] rounded-md flex items-center gap-2 w-full sm:w-auto justify-center"
              >
                <Download size={17} /> Download report
              </button>
              <button
                onClick={() => setSaveCopyModal(true)}
                className="text-[.8rem] btn-orange px-3 py-[.4rem] rounded-md flex items-center gap-2 w-full sm:w-auto justify-center"
              >
                Create Resume Copy{" "}
                <Tooltip
                  title="Create a new resume copy that includes AI-recommended improvements."
                  overlayInnerStyle={{
                    background: "black",
                    textAlign: "center",
                    padding: 4,
                    fontSize: 14,
                  }}
                >
                  <HelpCircle size={17} />
                </Tooltip>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportHeader;
